import { useRouter } from "next/router";
import Spinner from "../icons/Spinner";

const Loading2 = ({ loadingString }) => {
  const { locale } = useRouter();
  return (
    <div className="flex flex-col items-center justify-center gap-5 min-h-96 text-slate-400">
      <Spinner width={100} />
      <div className="uppercase font-bold text-xl">
        { loadingString || locale === "en" ? "Loading..." : "جار التحميل..."}
      </div>
    </div>
  );
};

export default Loading2;
